// Custom-FAQ-Tabs
$(document).ready(function(){
$('.redirect_sert').click(function() {
          window.location.href = "https://techable.com/collections/lightning-deals";
}); 
  // Index Tabs
  $('ul.custom li:first-child label').addClass('active');
  $('.tabs__item-label').click(function(){
        $('.tabs__item-label').removeClass('active'); // Remove active from all labels
        $(this).addClass('active'); // Add active only to the clicked label
    });
// end index tabs

$("#All_item_nav_btn").on('click',function(){
  $(this).toggleClass('All_items_nav_active');
  $('body').toggleClass('body_All_items_nav_active');
  $(".All_item_menu_section").toggleClass('All_item_sidebar_active');
  $(".All_item_sub_menus").hide();
});

$(".All_item_sidebar a").on("mouseover",function(){
$(".All_item_sub_menus").show();
$(".All_items_sub_nav").hide();  
var subitem = $(this).attr('data-sub-index');
$('.sub_nav_'+subitem).show();
});  

$("#All_item_close_btn").on("click",function(){
  $(".All_items_nav_active").removeClass('All_items_nav_active');
  $('body').removeClass('body_All_items_nav_active');
  $(".All_item_menu_section").removeClass('All_item_sidebar_active');
  $(".All_item_sub_menus").hide();
});

    $('.smlIcon').removeClass("rotate");
  $('.smlIcon').addClass("ScaleIn");
   setTimeout(function () {
     $(".smlIcon").addClass("Scaleout");
     $('.smlIcon').removeClass("ScaleIn"); 
   },1000); 

   setTimeout(function () {
     $(".smlIcon").removeClass("Scaleout");
  $(".smlIcon").addClass("rotate");
   },1500); 
  
  $(".logoOuter").on("mouseenter",function(){
  $('.smlIcon').removeClass("rotate");
  $('.smlIcon').addClass("ScaleIn");
   setTimeout(function () {
     $(".smlIcon").addClass("Scaleout");
     $('.smlIcon').removeClass("ScaleIn");
   },500); 

   setTimeout(function () {
     $(".smlIcon").removeClass("Scaleout");
  $(".smlIcon").addClass("rotate");
   },1000); 
  
}); 
 $('.header-clmenu').click(function(){
    $('html').toggleClass('mobile-menu');
});

// hesder js end
 var slick = $(".gallery_slider");

// Check if there's more than 1 slide
if ($.fn && $.fn.slick && slick.children().length > 1) {
    slick.slick({
        infinite: true,
        autoplay: false,
        autoplaySpeed: 5000,
        speed: 1000,
        arrows: true,  // Show navigation buttons only if multiple slides
        prevArrow: $('.back-me'),
        nextArrow: $('.go-me'),
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true
                }
            }
        ]
    });
} else if (slick.children().length <= 1) {
    $('.back-me, .go-me').hide();
}

  $('ul.shopify-tabs > li').click(function(){
    var tab_id = $(this).attr('data-tab');
    $(this).parent().find('li').removeClass('current');
    $('.shopify-tab-content').removeClass('current');
    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  });
  
// Accessory_recommendation_slider code
$(document).on('click', '.item_addbtn', function() {
    var accessoryId = $(this).attr('itemId');
    var $button = $(this); // Store reference to the button
    $button.prop('disabled', true); // Disable the button
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { id: accessoryId, quantity: 1 },
      dataType: 'json',
      success: function(data) {
        $button.prop('disabled', false);
        showPopup('Item added to cart!', 'success');      
      },
      error: function(xhr, status, error) {
        showPopup('Failed to add item to cart.', 'error');
      }
    });
});

 // Function to display a popup message in a different div
function showPopup(message, type) {
    var $popup = $('#notification'); // Update this to the new div id or class
    // Set the message text
    $popup.text(message);
    // Set the color based on the type
    if (type === 'success') {
        $popup.css('background-color', 'green');
        $popup.css('color', 'white');
    } else if (type === 'error') {
        $popup.css('background-color', 'red');
        $popup.css('color', 'white');
    }
    // Show the popup
    $popup.fadeIn();

    // Hide the popup after 3 seconds
    setTimeout(function() {
        $popup.fadeOut();
    }, 3000);
}

if ($.fn && $.fn.slick && $('.recommend_accesory').length) {
$('.recommend_accesory').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow:3,
  slidesToScroll: 1,
  arrow:true,
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
     {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, 
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        // centerMode : true
      }
    }   
  ]
});
}

if ($.fn && $.fn.slick && $('.multiple-items').length) {
 $('.multiple-items').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
     infinite: true,
     arrows: true,
     prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg class="feather feather-chevron-right" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><polyline points="9 18 15 12 9 6"/></svg></button>',
      nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg class="feather feather-chevron-right" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><polyline points="9 18 15 12 9 6"/></svg></button>',
       responsive: [
         {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
}
 
  // APSearch.liquid
  
   $('.TCtabs_Headng').click(function(){
   var contentDiv = $(this).next('.TesPage');
       var wrapperDiv = $(this).closest('.contWrpper');
   
    if(contentDiv.is(':visible')) {
      contentDiv.hide();
      wrapperDiv.removeClass('active');
    } else {
      $('.TesPage').hide();
      contentDiv.show();
       $('.contWrpper').removeClass('active');
        wrapperDiv.addClass('active');
    }
  });
  
  // Initialize first tab and first content as visible
  $('.shopify-tabs li:first-child').addClass('current');
  $('.shopify-tb-content:first-child').addClass('current');
  $('.TesPage').hide(); // Hide all initially
  $('#tab1').show(); // Show the first TesPage content
  $('#icact1').addClass('active');

  $(document).on('click','.SingleTemp_button',function(){
    $('.CustomWholesale_Form').addClass('Open_popup');
    $('body').addClass('Open_popup');    
});

 $(document).on('click','.CrossIcon',function(){
   $('.CustomWholesale_Form').removeClass('Open_popup');
   $('body').removeClass('Open_popup'); 
 }); 

const qty = $('input[name="quantity"]').val();

    $('.DIsTextWrapper').each(function () {
      if ($(this).attr('data-qnty') === qty) {
        $(this).css('display','block');
      } else {
        $(this).css('display','none');
      }
    });
 
$('button[name="plus"], button[name="minus"]').on('click', function () {
  setTimeout(function () {
    const qty = $('input[name="quantity"]').val();

    $('.DIsTextWrapper').each(function () {
      if ($(this).attr('data-qnty') === qty) {
        $(this).css('display','block');
      } else {
        $(this).css('display','none');
      }
    });
  }, 100);
});
  $(document).on('click','.mobile-facets__inner .close_csrt',function(){
$('body').removeClass('open-drawer-filter-drawer');
    
});

// apple-search

$("#serial_number").on('change',function(){
$('#search_serial').submit();  
});  
$('#search_serial').on('submit',function(event){
  event.preventDefault();
    var serial_number = $("#serial_number").val();
        let newParam = serial_number.split(" ").join("+");      
    var url = '/pages/mac-lookup?search='+newParam;
    location.replace(url);

});
   $('#button-2').click(function(){
      $('.apple-predictive-search').toggle();
      let  curr_css =  $('.apple-predictive-search').css('display')
       if(curr_css == "block"){
         $('.serial-number-search').addClass('hide_serial');
       }else{
          $('.serial-number-search').removeClass('hide_serial');
       }
   });

  $("#search_type").on('change',function(){
   var search_type = $(this).val();    
    if(search_type == "with_title"){
      $(".apple-predictive-search").show();
      $(".serial-number-search").hide();
    }else{
         $(".apple-predictive-search").hide();
      $(".serial-number-search").show();
    }
  });

  // animation with text 
   $('.alert_message').click(function () {
    alert('Press Ctrl+D to bookmark this page.')
  })

 $(".footer-block__heading").click(function(){
  $(".footer-block__details-content list-unstyled").toggle();
});


});


// Product page contact button
 // var dataprice = $('.product-form__input__radio').attr('data-price');
 //  if (dataprice === '$0.00') {
 //    $('.CustomVariant_btn').css('display', 'block');
 //    $('.product-form__submit').hide();
 //  } else {
 //    $('.CustomVariant_btn').css('display', 'none');
 //    $('.product-form__submit').show();
 //  }

// $(document).on('change', '.product-form__input__radio', function () {
//   var dataprice = $(this).attr('data-price');
//   if (dataprice === '$0.00') {
//     $('.CustomVariant_btn').css('display', 'block');
//     $('.product-form__submit').hide();
//   } else {
//     $('.CustomVariant_btn').css('display', 'none');
//     $('.product-form__submit').show();
//   }
// });

// function handleVariantDisplay() {
//   // Get the checked radio input
//   var $selectedInput = $('.product-form__input__radio:checked');
//   var dataprice = $selectedInput.attr('data-price');
//   if (dataprice === '$0.00') {
//     $('.CustomVariant_btn').css('display', 'block');
//     $('.product-form__submit').hide();
//   } else {
//     $('.CustomVariant_btn').css('display', 'none');
//     $('.product-form__submit').show();
//   }
// }

// // On page load
// $(document).ready(function () {
//   handleVariantDisplay();
// });


// $(document).on('change', '.product-form__input__radio', function () {
//   var selectedOptions = [];
  
//   $('.product-form__input__radio:checked').each(function () {
//     var val = $(this).val(); 
//     selectedOptions.push(val);
//   });

//   var combinedTitle = selectedOptions.join(' / ');

//   $('.CustomHiddenSelec option').each(function () {
//     var getval = $(this).text().trim(); 
//     var varprice = $(this).attr('varprice');

//     if (combinedTitle === getval) {      
//     }

//   });
// });


// $(document).on('change', '.product-form__input__radio', function () {
//   var selectedOptions = [];

//   $('.product-form__input__radio:checked').each(function () {
//     var val = $(this).val(); 
//     selectedOptions.push(val);
//   });

//   var combinedTitle = selectedOptions.join(' / ');
//   var matched = false;

//   $('.CustomHiddenSelec option').each(function () {
//     var getval = $(this).text().trim();
//     var rawPrice = $(this).attr('varprice') || '';
    
//     // Remove "$" and convert to number
//     var varprice = parseFloat(rawPrice.replace('$', '')) || 0;

//     if (combinedTitle === getval) {
//       matched = true;

//       if (varprice === 0) {
//         $('.CustomVariant_btn').css('display', 'block');
//         $('.product-form__submit').hide();
//       } else {
//         $('.CustomVariant_btn').css('display', 'none');
//         $('.product-form__submit').show();
//       }
//     }
//   });

//   // Optional: fallback if no match
//   if (!matched) {
//     $('.CustomVariant_btn').css('display', 'none');
//     $('.product-form__submit').show();
//   }
// });